import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Component } from "lucide-react";
import { DynamicIcon } from "lucide-react/dynamic";

const PageHeader = ({
  heading,
  description,
  headingIcon,
  navigationText,
  navigateTo,
  navigtionState,
  customClasses = "",
  customElements = null,
  navButtonClass = "flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors duration-200 group w-fit",
}) => {
  const navigate = useNavigate();
  const toKebabCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  };

  const navigateToDestination = (...args) => {
    if (typeof navigateTo == "function") {
      return navigateTo(...args);
    }
    return navigate(navigateTo, navigtionState ?? {});
  };

  return (
    <div className={`flex flex-col gap-5 ${customClasses}`}>
      {/* Navigation Link */}
      {navigationText && (
        <button
          onClick={navigateToDestination}
          className={navButtonClass}
        >
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
          <span className="text-sm font-medium font-['Inter']">
            {navigationText}
          </span>
        </button>
      )}

      {/* Main Header Content */}
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div className="flex flex-col gap-1.5">
          {(heading || headingIcon) && (
            <div className="flex gap-3 items-center">
              {headingIcon && (
                <DynamicIcon
                  name={toKebabCase(headingIcon)}
                  className="w-7 h-7 text-foreground"
                />
              )}
              {heading && (
                <h1 className="text-foreground text-2xl font-semibold font-['Inter'] leading-8">
                  {heading}
                </h1>
              )}
            </div>
          )}
          {description && (
            <p className="text-muted-foreground text-base font-normal font-['Inter'] leading-6">
              {description}
            </p>
          )}
        </div>

        {/* Action Elements */}
        {customElements && (
          <div className="flex items-center gap-3">
            {typeof customElements === "function"
              ? customElements()
              : customElements}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
